import http from '@/utils/http';

export default {
  async getById(id) {
    return await http.get(`/api/emergency_info/get/${id}`);
  },
  async insert(data) {
    return await http.post('/api/emergency_info/insert', data);
  },
  async update(data) {
    return await http.post('/api/emergency_info/update', data);
  },
  async delete(data) {
    return await http.post('/api/emergency_info/delete', data);
  },
  async getListByUser(id_user) {
    return await http.get(`/api/emergency_info/list-by-user/${id_user}`);
  }
};